import React, { useContext } from "react";
import { Box } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";
import { BannerContext } from "../../context";
import EmptyOrder from "../content/EmptyOrder";
import FilledOrder from "../content/FilledOrder";

function Main() {
  const { isOnJSM, itemsInCart } = useContext(BannerContext);

  return (
    <Box
      padding="space.300"
      style={{
        borderRadius: "3px",
        background: token("color.background.accent.gray.subtlest"),
      }}
    >
      <Box backgroundColor="elevation.surface.raised">
        {isOnJSM && !!itemsInCart?.length ? <FilledOrder /> : <EmptyOrder />}
      </Box>
    </Box>
  );
}

export default Main;
